import React from 'react';

import { onboardingTestIDs } from '@constants';

import { SubscriptionSelectionContent } from './components/SubscriptionSelectionContent';

import { TWCPage } from '../../components/primitives/TWCPage/TWCPage';

export const SubscriptionSelectionPage = () => (
  <TWCPage
    childIds={[onboardingTestIDs.subscriptionSelection.monthlyTile, onboardingTestIDs.subscriptionSelection.yearlyTile]}
    firstFocus={onboardingTestIDs.subscriptionSelection.monthlyTile}
    pageID={onboardingTestIDs.pages.subscriptionSelectionPage}
  >
    <SubscriptionSelectionContent.API />
  </TWCPage>
);
